import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const NfHotelInstallationForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<>
			<FormInput
				name="settings.api_key"
				errors={errors}
				register={register}
				label={t("modules.app.field.api_key.title")}
			/>
			<FormInput
				name="settings.instance_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.instance_id.title")}
			/>
		</>
	);
};

export default NfHotelInstallationForm;
